export default "__VITE_ASSET__92b06ce2__"